import { hash } from 'immutable';
import { combineActions, handleActions } from 'redux-actions';

import type { AsyncDispatch } from '../../utils/redux-store/asyncDispatchMiddleware';
import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';
import { coreActions } from '../core-actions';
import * as actions from './securitiesActions';
import type { SecurityProps } from './securitiesTypes';

export const QcsSyncSecuritiesStoreFactory = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<SecurityProps>();

const reducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<SecurityProps>,
  | coreActions.SanitizeAction
  | ReturnType<typeof actions.createSecurity>
  | ReturnType<typeof actions.createSecuritySuccess>
  | ReturnType<typeof actions.updateSecurity>
  | ReturnType<typeof actions.updateSecuritySuccess>
  | ReturnType<typeof actions.deleteSecurity>
  | ReturnType<typeof actions.deleteSecuritySuccess>
  | ReturnType<typeof actions.getSecurities>
  | ReturnType<typeof actions.getSecuritiesSuccess>
  | ReturnType<typeof actions.getSecuritiesFailure>
>(
  {
    [coreActions.SANITIZE]: (state) =>
      state.set(
        'resourcesById',
        state.resourcesById.map((resource) =>
          resource.merge({
            name: hash(resource.name).toString(),
          }),
        ),
      ),

    [actions.createSecurity.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.createSecuritySuccess.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.deleteSecurity),
    [actions.updateSecurity.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateSecurity),
    [actions.updateSecuritySuccess.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.deleteSecurity.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createSecurity),
    [actions.deleteSecuritySuccess.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [actions.getSecurities.type]: (state) => state.set('isLoading', true),
    [actions.getSecuritiesSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),
    [actions.getSecuritiesFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),

    [combineActions(
      actions.createSecurityFailure,
      actions.updateSecurityFailure,
      actions.deleteSecurityFailure,
    ).toString()]: (
      state: resourceStoreTypes.QcsSyncResourceStore<SecurityProps>,
      { payload: error, asyncDispatch }: { payload: unknown; asyncDispatch: AsyncDispatch },
    ) => {
      // FIXME: refactor this to a saga
      asyncDispatch(actions.getSecurities());
      return resourceUpserters.resetResources(state, error);
    },
  },
  QcsSyncSecuritiesStoreFactory(),
);

export default reducer;
